import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import { history } from './helpers';
import { alertActions } from './actions';
import { PrivateRoute } from './components/PrivateRoute';
import { LoginPage } from './components/LoginPage';
import { LoginPage as LoginPageCHIEF } from './components/LoginPageCHIEF';
import { LoginPage as LoginPageEAST } from './components/LoginPageEast';
import Main from './components/Main';

import '@coreui/icons/css/coreui-icons.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'simple-line-icons/css/simple-line-icons.css';
import "./style/App.css";

// import 'vis/dist/vis-network.min.css';  //important for visjs network digram to show the popup title
import 'rc-time-picker/assets/index.css';


// for chief login page
import './wassets/css/style.css';
// import './wassets/css/style_rs.css';


function mapStateToProps(state) {
	const { alert } = state;
	return { alert };
}
// the hostname of this site
const domainname = window.location.hostname;
console.log('this website is host in => ', domainname)
const loginComponent = domainname==='newlowi.chiefappc.com' ? LoginPageCHIEF : domainname === 'social.isurvey.com.tw' ? LoginPageEAST : LoginPage;

class App extends Component {
	constructor(props) {
	    super(props);

	    const { dispatch } = this.props;
	    history.listen((location, action) => {
	        // clear alert on location change
	        dispatch(alertActions.clear());
	    });
	}
	render() {
		const { alert } = this.props;
		return (
			<div>
				{alert.message &&
					<div className="alert">{alert.message}</div>
				}
				<Router history={history}>
					<Switch>
						<Route exact path="/login" name="login" component={loginComponent} />
						<PrivateRoute path="/" name="main" component={Main} />
					</Switch>
				</Router>
			</div>
		);
	}
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App };



// WEBPACK FOOTER //
// ./src/App.js